import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchEstimate = (payload) =>
  axios.post(`${API}/estimate`, payload).then((r) => r.data);

export const createReservation = (payload) =>
  axios.post(`${API}/reservations`, payload).then((r) => r.data);

export const fetchReservation = (code) =>
  axios.get(`${API}/reservations/${encodeURIComponent(code)}`).then((r) => r.data);

export const fetchDemandes = (pin) =>
  axios.post(`${API}/demandes`, { pin }).then((r) => r.data);

export const deleteDemande = (code, pin) =>
  axios.delete(`${API}/reservations/${encodeURIComponent(code)}`, { data: { pin } }).then((r) => r.data);
